'use strict';

const ICON_SELECTOR = '.js-icon-search';
const INPUT_SELECTOR = '.global-search__query';

export function init() {
    const element = document.querySelector(ICON_SELECTOR);

    if (!element) {
        return false;
    }

    element.addEventListener('click', () => {
        document.querySelector(INPUT_SELECTOR).focus();
    })
}

export default { init }
